import { useCallback } from 'react';
import { useMetaTagsContext } from '@/creditflowresearch/application/MetaTags/MetaTagsContext';
import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';

export const useMetaTagsSetup = () => {
  const { setMetaTags } = useMetaTagsContext();

  return useCallback((): void => {
    setMetaTags(metaTags.getResearch());
  }, [setMetaTags]);
};
